<template>
  <div class="external-api-field">
    <!-- Header -->
    <div class="header-field">
      <div class="d-flex align-items-center">
        <div class="icon-ext-api">
          <img src="@/assets/new-form-ui/ext-api.svg">
        </div>
        <h4 class="title-field">External API</h4>
      </div>
      <p
        class="close-modal"
        @click="closeModal"
      >
        &times;
      </p>
    </div>

    <!-- Content -->
    <div class="external-api-content">
      <!-- Endpoint Section -->
      <div class="content-section">
        <p class="title-section">Endpoint</p>

        <b-row>
          <b-col cols="3">
            <b-form :class="{'error-input' : $v.dataSetup.method.$error}">
              <label> Method </label>
              <j-single-select
                v-model="$v.dataSetup.method.$model"
                :options="methodOptions"
                :placeholder="'Select'"
                label="label"/>
            </b-form>
          </b-col>
          <b-col cols="9">
            <b-form :class="{'error-input' : $v.dataSetup.url.$error}">
              <label> URL </label>
              <j-input
                v-model="$v.dataSetup.url.$model"
                placeholder="Enter URL/Endpoint"/>
            </b-form>
          </b-col>
        </b-row>
        <b-form :class="{'error-input' : $v.dataSetup.source.$error}">
          <label> Variable Source </label>
          <j-input
            v-model="$v.dataSetup.source.$model"
            placeholder="Enter Variable Source"/>
        </b-form>
      </div>

      <!-- Header Section -->
      <div class="content-section">
        <p class="title-section">Header</p>

        <div
          v-for="(data, index) in dataSetup.header"
          :key="index + 0"
          class="form-list"
        >
          <input
            v-model="data.name"
            type="text"
            placeholder="Name"
            class="name"
          >
          <input
            v-model="data.value"
            type="text"
            placeholder="Value"
            class="value"
          >
          <i
            class="fa fa-trash"
            @click="deleteHeader(index)"
          />
        </div>
        <div
          class="btn-add-config"
          @click="addHeader">
          + Add Header
        </div>
      </div>

      <!-- Params Section -->
      <div
        v-if="dataSetup.method === 'GET'"
        class="content-section border-0"
      >
        <p class="title-section">Params</p>

        <div
          v-for="(data, index) in dataSetup.params"
          :key="index + 0"
          class="form-list"
        >
          <input
            v-model="data.variable"
            type="text"
            placeholder="Variable"
            class="name"
          >
          <input
            v-model="data.value"
            type="text"
            placeholder="Value"
            class="value"
          >
          <i
            class="fa fa-trash"
            @click="deleteParams(index)"
          />
        </div>
        <div
          class="btn-add-config"
          @click="addParams">
          + Add Params
        </div>
      </div>

      <!-- Payload and Body Section -->
      <div
        v-else
        class="content-section border-0"
      >
        <b-row v-if="showEditor">
          <b-col cols="12">
            <b-form>
              <label> Body </label>
              <j-monaco-editor
                ref="scriptBody"
                :value="dataSetup.payload.body"
                height="200px"
              />
            </b-form>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- Footer -->
    <div class="external-api-footer">
      <button
        class="button-border mr-2"
        @click="closeModal"
      >
        Close
      </button>
      <button
        class="button-blue"
        @click="submitForm"
      >
        Set
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';

export default {
  components: {
    jMonacoEditor,
  },

  validations: {
    dataSetup: {
      method: {
        required,
      },
      url: {
        required,
      },
      source: {},
      header: {},
      params: {},
      variable: {},
      payload: {
        body: {},
      },
    },
  },

  data() {
    return {
      showEditor: false,
      dataSetup: {
        method: null,
        url: null,
        source: null,
        header: [],
        params: [],
        variable: [],
        payload: {
          body: '',
        },
      },
      methodOptions: [
        {
          id: 'GET',
          label: 'GET',
          text: 'GET',
        },
        {
          id: 'POST',
          label: 'POST',
          text: 'POST',
        },
        {
          id: 'PUT',
          label: 'PUT',
          text: 'PUT',
        },
        {
          id: 'PATCH',
          label: 'PATCH',
          text: 'PATCH',
        },
        {
          id: 'DELETE',
          label: 'DELETE',
          text: 'DELETE',
        },
      ],
      payloadOptions: [
        // {
        //   id: 'json',
        //   label: 'JSON',
        //   text: 'JSON',
        // },
        {
          id: 'raw',
          label: 'RAW',
          text: 'RAW',
        },
      ],
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', ['sourceExternalApi']),
  },

  watch: {
    // eslint-disable-next-line func-names
    'dataSetup.method': function (val) {
      if (val !== 'GET') {
        setTimeout(() => {
          this.showEditor = true;
        }, 200);
      } else {
        this.showEditor = false;
      }
    },
  },

  created() {
    if (this.sourceExternalApi) {
      // eslint-disable-next-line
      const { method, url, source, header, query_params, body, variables } = this.sourceExternalApi;
      this.dataSetup.method = method;
      this.dataSetup.url = url;
      this.dataSetup.source = source;
      this.dataSetup.payload.body = body;

      if (header) {
        const headerData = Object.keys(header);
        const headerValueData = Object.values(header);
        this.dataSetup.header = headerData.map((e, index) => ({
          name: e,
          value: headerValueData[index],
        }));
      }

      const paramsData = Object.keys(query_params);
      const paramsValueData = Object.values(query_params);
      this.dataSetup.params = paramsData.map((e, index) => ({
        variable: e,
        value: paramsValueData[index],
      }));

      setTimeout(() => {
        if (this.dataSetup.method !== 'GET') {
          this.showEditor = true;
        }
      }, 200);

      // const variableData = Object.keys(variables);
      // const variableValueData = Object.values(variables);
      // this.dataSetup.variable = variableData.map((e, index) => ({
      //   variable: e,
      //   value: variableValueData[index],
      // }));
    }
  },

  methods: {
    ...mapActions('jStoreExperienceManagerV2', ['toggleModalExternalApi']),

    addHeader() {
      this.dataSetup.header.push({
        name: null,
        value: null,
      });
    },

    deleteHeader(index) {
      this.dataSetup.header.splice(index, 1);
    },

    addParams() {
      this.dataSetup.params.push({
        variable: null,
        value: null,
      });
    },

    deleteParams(index) {
      this.dataSetup.params.splice(index, 1);
    },

    addVariable() {
      this.dataSetup.variable.push({
        variable: null,
        value: null,
      });
    },

    deleteVariable(index) {
      this.dataSetup.variable.splice(index, 1);
    },

    closeModal() {
      this.toggleModalExternalApi({ status: false, data: null });
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        const { method, url, source, header, params, variable } = this.dataSetup;

        const dataHeader = {};
        header.forEach((element) => {
          dataHeader[element.name] = element.value;
        });
        const dataParams = {};
        params.forEach((element) => {
          dataParams[element.variable] = element.value;
        });
        const dataVariable = {};
        variable.forEach((element) => {
          dataVariable[element.variable] = element.value;
        });
        const newVal = {
          url,
          method,
          source,
          header: dataHeader,
          query_params: dataParams,
          body: typeof this.$refs.scriptBody !== 'undefined' ? this.$refs.scriptBody.getData() : '',
          variables: dataVariable,
        };
        this.toggleModalExternalApi({ status: false, data: newVal });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalExternalApiField.vue